/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Agent_Unattended_External_Writes_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "Autonomous agents may now perform external writes, such as creating an invoice, without human approval. Actions oneAI recognises as irreversible still need t..." |
*
* @param {Audit_Details_Agent_Unattended_External_Writes_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_unattended_external_writes_enabled_desc = /** @type {((inputs?: Audit_Details_Agent_Unattended_External_Writes_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Unattended_External_Writes_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Autonome Agenten dürfen jetzt externe Schreibvorgänge wie das Erstellen einer Rechnung ohne menschliche Genehmigung ausführen. Aktionen, die oneAI als unumkehrbar erkennt, brauchen weiterhin die Einstellung für unumkehrbare Aktionen.")
	return /** @type {LocalizedString} */ ("Autonomous agents may now perform external writes, such as creating an invoice, without human approval. Actions oneAI recognises as irreversible still need the irreversible-actions setting.")
});